<template>
  <div :style="{direction:$t('direction')}">
    <div class="dashboard">
      <Sidebar />
      <div class="content profile-content">
        <Header />
        <div class="dashboard-content">
          <div class="dashboard-wrapper">

            <div class="ar-card size-sm">
              <div class="ar-card-header">
                <div class="ar-card-title">
                  ویرایش اطلاعات حساب کاربری 
                </div>
                <span></span>
              </div>
              <div class="ar-card-body profile-info text-primary-dark">

                <div class="profile-img-wrapper" v-if="user_data.user_detail">
                  <div class="user-prof">
                    <img ref="profile_pic" v-if="user_data.user_detail.profile_picture" class="user-prof-img" :src="this.ImageUrl+user_data.user_detail.profile_picture" alt="">
                    <img ref="profile_pic" v-else class="user-prof-img" :src="this.StaticImageUrl+'assets/images/empty-user.png'" alt="">
                  </div>
                  <input @change="profile_picture" ref="profile_picture" type="file" class="file-hidden" id="profile_picture">
                  <label for="profile_picture"><div class="fileinput ar-btn size-xm info round">تغییر تصویر پروفایل</div></label>
                </div>

                <div class="profile-titr">
                  <h4>اطلاعات فردی</h4>
                </div>

                <div class="form-row">

                  <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="ar-form-group">
                      <label>نام و نام خانوادگی</label>
                      <input class="ar-form-control" disabled v-model="user_data.fullname" placeholder="example@gmail.com">
                      <div v-if="errors.fullname" class="ar-form-text">
                        <small>{{errors.fullname[0]}}</small>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="ar-form-group">
                      <label>کد ملی</label>
                      <input class="ar-form-control latin-input-1" disabled v-model="user_data.national_code" placeholder="example@gmail.com">
                      <div v-if="errors.national_code" class="ar-form-text">
                        <small>{{errors.national_code[0]}}</small>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="ar-form-group">
                      <label>نام پدر</label>
                      <input class="ar-form-control" v-model="user_data.parent_name">
                      <div v-if="errors.parent_name" class="ar-form-text">
                        <small>{{errors.parent_name[0]}}</small>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="ar-form-group">
                      <label>تاریخ تولد</label>
                      <input class="ar-form-control latin-input-1" disabled v-model="user_data.birth_date" placeholder="example@gmail.com">
                      <div v-if="errors.birth_date" class="ar-form-text">
                        <small>{{errors.birth_date[0]}}</small>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="ar-form-group">
                      <label>ایمیل</label>
                      <input class="ar-form-control latin-input-1" type="email" v-model="user_data.email">
                      <div v-if="errors.email" class="ar-form-text">
                        <small>{{errors.email[0]}}</small>
                      </div>
                    </div>
                  </div>

                </div>

                <div class="profile-titr">
                  <h4>اطلاعات تماس</h4>
                </div>

                <div class="form-row">

                  <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="ar-form-group">
                      <label>شماره تماس</label>
                      <input class="ar-form-control latin-input-1" disabled v-model="user_data.mobile_number">
                    </div>
                  </div>

                  <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="ar-form-group">
                      <label>تلفن ثابت</label>
                      <input class="ar-form-control latin-input-1" v-model="user_data.phone_number">
                      <div v-if="errors.phone_number" class="auth-input-error text-danger">
                        {{errors.phone_number[0]}}
                      </div>
                    </div>
                  </div>
                
                </div>

                <div class="profile-titr">
                  <h4>اطلاعات محل سکونت</h4>
                </div>

                <div class="form-row">

                  <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="ar-form-group">
                      <label>استان محل سکونت</label>
                      <v-select v-model="user_data.province" :options="provinces" class="ar-form-control"></v-select>
                      <div v-if="errors.province" class="ar-form-text">
                        <small>{{errors.province[0]}}</small>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="ar-form-group">
                      <label>شهر محل سکونت</label>
                      <v-select v-model="user_data.city" :options="cities" class="ar-form-control"></v-select>
                      <div v-if="errors.city" class="ar-form-text">
                        <small>{{errors.city[0]}}</small>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="ar-form-group">
                      <label>آدرس محل سکونت</label>
                      <textarea class="ar-form-control" rows="3" v-model="user_data.address"></textarea>
                      <div v-if="errors.address" class="ar-form-text">
                        <small>{{errors.address[0]}}</small>
                      </div>
                    </div>
                  </div>

                </div>

                <div class="text-center mt-0 mb-2 mt-2">
                  <button @click="updateProfile()" class="ar-btn size-lg primary round"> ثبت اطلاعات</button>
                </div>
                
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Sidebar from './partials/Sidebar'
import Header from './partials/Header'
import vSelect from 'vue-select'
import {io} from 'socket.io-client';
import cities from '../../plugins/cities'
import provinces from '../../plugins/provinces'
export default {
  name: 'Profile',
  components:{
    Sidebar,
    Header,
    vSelect
  },
  data : () => ({
    user_data:{},
    errors:{},
    add_call_number:false,
    socket : null,
    cities,
    provinces
  }),
  methods:{
    profile_picture(event){
      this.user_data.profile_picture = this.$refs.profile_picture.files[0];
      this.$refs.profile_pic.src = URL.createObjectURL(this.user_data.profile_picture);
    },
    getUserData(){
      this.activeLoading(true)
      const api_token = this.getToken()
      this.$axios.post(`getUserData`,{},
      {
        headers: {
          'api_token':api_token
        }
      })
      .then(res => {
        this.user_data = res.data.data
        this.activeLoading(false)
      })
      .catch(err => {
        this.activeLoading(false)
      });
    },
    updateProfile(){
      const x = this.user_data;
      const form = new FormData();
      if(this.user_data.parent_name){
        form.append('parent_name', this.user_data.parent_name);
      }
      if(x.email){
        form.append('email', x.email);
      }
      if(x.address){
        form.append('address', x.address);
      }
      if(x.province){
        form.append('province', x.province);
      }
      if(x.city){
        form.append('city', x.city);
      }
      if(x.phone_number){
        form.append('phone_number', x.phone_number);
      }
      if(x.profile_picture){
        form.append('profile_picture', x.profile_picture);
      }
      
      this.activeLoading(true)
      const api_token = this.getToken()

      this.$axios.post(`updateProfile`,form,
      {
        headers: {
          'api_token':api_token
        }
      })
      .then(res => {
        this.authUser(res.data.data)
        this.socket.emit('admin_notification');
        this.activeLoading(false)
        this.$router.replace({name:'Dashboard'})
      })
      .catch(err => {
        this.errors = err.response.data.errors
        this.activeLoading(false)
      });
    }
  },
  mounted() {
    this.activeLoading(false)
    this.socket = io(this.socketUrl);
    this.checkAuth()
    this.checkConfirmed()
    this.getUserData()
  }
}
</script>
<style>
.vs__dropdown-menu{
  text-align: right;
}
.profile-info .v-select {
  height: auto !important;
}
.vs__selected-options input {
    width: 100% !important;
}
</style>